import { Tip, TipType } from "../../../Tip/Tip"

export const TipSamsonYandex = () => {
  return (
    <Tip
      type={TipType.WARNING}
      content={
        <span>
          <b>Внимание! </b>
          <p>
            Файл перекодировки должен быть формата <b> XLSX </b> и содержать
            следующие <b> обязательные </b> колонки:
          </p>
          <ol style={{ textAlign: "left" }}>
            <li>
              <b>article </b> - артикул товара с Самсон ОПТ
            </li>
            <li>
              <b>offer_id </b> - артикул продавца с Яндекс маркета
            </li>
            <li>
              <b>sizes </b> - размеры упаковки, в см. В формате: "10;10;10";
            </li>
            <li>
              <b>weight </b> - вес товара в кг, с учетом кратности.
            </li>
            <li>
              <b>count </b> - количество товаров продаваемых в карточке
              (кратность)
            </li>
          </ol>
        </span>
      }
    />
  )
}
